import { IdentificationType } from './identification-type.enum';
import { RequestType } from './request-type.enum';
import { ReasonForResignation } from './reason-for-resignation.enum';
import { TypeOfMaintenance } from './type-of-maintenance.enum';

export class RequestModel {
  providerType: string;
  requestType: RequestType;
  name: string;
  idType: any;
  country: string;
  NPI: any;
  taxID: string;
  providerID: any;
  state: string[];
  requestDetails: string;
  middleInitial: string;
  lastName: string;
  reasonForResignation: ReasonForResignation;
  maintenanceType: TypeOfMaintenance;
  doc: File;
  caqhId: string;
  fileType: string;
  gateway: boolean;
  effDate: Date;
  optDocs: File[];

  constructor(
    providerType?: string,
    requestType?: RequestType,
    name?: string,
    idType?: IdentificationType,
    country?: string,
    state?: string[],
    requestDetails?: string,
    lastName?: string,
    middleInitial?: string,
    reasonForResignation?: ReasonForResignation,
    doc?: File,
    caqhId?: string,
    fileType?: string,
    gateway?: boolean,
    effDate?: Date,
    NPI?: any,
    taxID?: string,
    providerID?: any,
    optDocs?: File[]
  ) {
    this.providerType = providerType;
    this.requestType = requestType;
    this.name = name;
    this.idType = idType;
    this.country = country;
    this.state = state;
    this.requestDetails = requestDetails;
    this.middleInitial = middleInitial;
    this.lastName = lastName;
    this.reasonForResignation = reasonForResignation;
    this.doc = doc;
    this.caqhId = caqhId;
    this.fileType = fileType;
    this.gateway = gateway;
    this.effDate = effDate;
    this.NPI = NPI;
    this.providerID = providerID;
    this.taxID = taxID;
    this.optDocs = optDocs;
  }
}
